import type { Dispatch } from 'redux';
import {
    createActionFactoryForFeature,
    Feature,
    UnifiedGroup,
    createActionFactory,
} from '../../shared';

const actionFactory = createActionFactoryForFeature(Feature.UnifiedGroups);
export const createGroupClickedAction = createActionFactory<{ origin: NewGroupOrigin }>(
    'CreateGroupClickedAction',
    Feature.UnifiedGroups,
    action => ({
        source: action.payload.origin,
    })
);

export const createGroupCompletedAction = actionFactory<{ group: UnifiedGroup }>(
    'CreateGroupCompletedAction'
);

export const addMemberCompletedAction = actionFactory<{}>('AddMemberCompletedAction');

export const dismissCreateGroupDialogAction = actionFactory<{ group: UnifiedGroup }>(
    'DismissCreateGroupDialogAction'
);

export type NewGroupOrigin = 'commandBar' | 'leftNav' | 'emptyView';

export const createGroupClicked = (dispatch: Dispatch) => (origin: NewGroupOrigin) => {
    dispatch(createGroupClickedAction({ origin }));
};

export const onCreateGroupCompleted = (dispatch: Dispatch) => (group: UnifiedGroup) => {
    dispatch(createGroupCompletedAction({ group }));
};

export const onAddMemberCompleted = (dispatch: Dispatch): void => {
    dispatch(addMemberCompletedAction());
};

export const dismissCreateGroupDialog = (dispatch: Dispatch) => (group: UnifiedGroup) => {
    dispatch(dismissCreateGroupDialogAction({ group }));
};
export type { Action } from '../../shared';
